import { MapPin, Database, Users, User, PenSquare } from 'lucide-react';

interface BottomNavProps {
  activeTab: 'snares' | 'map' | 'database' | 'groups' | 'profile' | 'admin';
  onTabChange: (tab: 'snares' | 'map' | 'database' | 'groups' | 'profile' | 'admin') => void;
}

export function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  const tabs = [
    { id: 'snares' as const, icon: PenSquare, label: 'Log' },
    { id: 'map' as const, icon: MapPin, label: 'Map' },
    { id: 'database' as const, icon: Database, label: 'Database' },
    { id: 'groups' as const, icon: Users, label: 'Groups' },
    { id: 'profile' as const, icon: User, label: 'Profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-border safe-area-inset-bottom z-50">
      <div className="flex justify-around items-center h-16">
        {tabs.map(({ id, icon: Icon, label }) => (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
              activeTab === id
                ? 'text-primary'
                : 'text-muted-foreground'
            }`}
          >
            <Icon className="h-6 w-6 mb-1" />
            <span className="text-xs">{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
